import { render, staticRenderFns } from "./showParam.vue?vue&type=template&id=4855901a&scoped=true&"
import script from "./showParam.vue?vue&type=script&lang=js&"
export * from "./showParam.vue?vue&type=script&lang=js&"
import style0 from "./showParam.vue?vue&type=style&index=0&id=4855901a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855901a",
  null
  
)

export default component.exports